import React from "react";

import actionStyles from "./singleAssetActions.module.css";
import { resolveSingleAssetTrackingAction } from "./singleAssetTrackingActionModel.js";


export function SingleAssetTrackingAction({
  activeViewType,
  onToggleWatch,
  onViewHolding,
  showingRetainedWorkspace,
  trackedHolding,
  trackingBusy,
  watching,
}) {
  const action = resolveSingleAssetTrackingAction({
    viewType: activeViewType,
    hasTrackedHolding: Boolean(trackedHolding),
    watching,
    busy: trackingBusy,
    showingRetainedWorkspace,
  });
  if (!action) return null;
  const handler = {
    toggle_watch: onToggleWatch,
    view_holding: onViewHolding,
  }[action.kind];
  // 只分两类：撤销类（取消关注）一种样式，其余（加入关注 / 查看持仓）另一种。
  // 不按具体动作各配一种，否则同一个位置会冒出好几种长相。
  const undoing = action.kind === "toggle_watch" && watching;
  return (
    <button
      className={undoing ? actionStyles.undoButton : actionStyles.watchButton}
      type="button"
      disabled={action.disabled}
      onClick={handler}
    >
      {action.label}
    </button>
  );
}
